if(!customElements.get('custom-header')){
    class CustomHeaderPassword extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnPassword = this.querySelector('.btn-password-link');
            this.passwordPopup = this.querySelector('password-popup');

            this.btnPassword.addEventListener('click', this.openPasswordPopup.bind(this));

            this.passwordPopup.addEventListener('click', e => {
                if(e.target == this.passwordPopup){
                    this.closePasswordPopup();
                }
            })

            this.passwordPopupCloseBtn = this.passwordPopup.querySelector('.btn-close');
            this.passwordPopupCloseBtn.addEventListener('click', this.closePasswordPopup.bind(this));

            this.inputWrappers = this.querySelectorAll('.input-wrapper');
            this.inputs = this.querySelectorAll('input, textarea');
            this.inputs.forEach(item => {
                item.addEventListener('focus', this.focusOnInput.bind(this));
                item.addEventListener('focusout', this.focusOutOnInput.bind(this));
            });
            
            this.labels = this.querySelectorAll('.input-wrapper label');
            this.labels.forEach(item => {
              item.addEventListener('click', (e) => {
                if(e.currentTarget.closest('.input-wrapper').getAttribute('data-selected') != 'true'){
                  const inputs = e.currentTarget.closest('.input-wrapper').querySelectorAll('input, textarea');
                  inputs.forEach(item => {
                    item.focus();
                  })
                }
              })
            })

            // show popup if error displayed
            if(this.passwordPopup.querySelectorAll('.error').length > 0){
                this.openPasswordPopup();
            }
    
            if(this.getAttribute('data-sticky') == 'true'){
        
                // Sticky header
                this.enableStickyHeader();
                window.addEventListener('scroll', () => {
                this.enableStickyHeader();
                })
        
            }
        }

        openPasswordPopup(){
            this.passwordPopup.setAttribute('data-hidden', 'false');
            document.querySelector('html').style.overflow = 'hidden';

            // focus
            this.passwordPopup.querySelector('#password').focus();
            this.passwordPopup.addEventListener('keyup', e => {
                if(e.code?.toUpperCase() === 'ESCAPE') this.closePasswordPopup();
            })
        }

        closePasswordPopup(){
            this.passwordPopup.setAttribute('data-hidden', 'true');

            document.querySelector('html').style.overflow = 'initial';
        }

        enableStickyHeader(){
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
            if(scrollTop > 1){
                this.setAttribute('data-scroll', 'true');
            }else{
                this.setAttribute('data-scroll', 'false');
            }
        }

        focusOnInput(e){
            this.inputWrappers.forEach(item => {
                var input = item.querySelector('textarea, input');
                    if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
                })
        
                var currentTarget = e.currentTarget;
                var currentTargetInputWrapper = currentTarget.closest('.input-wrapper');
                currentTargetInputWrapper.setAttribute('data-selected', 'true');
            }
        
            focusOutOnInput(){
                this.inputWrappers.forEach(item => {
                    var input = item.querySelector('textarea, input');
                    if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
                })
            }
    }

    customElements.define('custom-header', CustomHeaderPassword);
}